// AUTHENTICATION
export const LOGIN = "/login";
export const CREATE_PASSWORD = "/create-password"
export const RESET_PASSWORD = "/reset-password"

//DATA
export const DATA_VISUALIZATION = "/data-visualization";
export const ART = "/art";
export const JEWELRY = "/jewelry";

//SETTINGS
export const ADMIN = "/admin";
export const USERS = "/admin/users";
export const COLUMNS = "/admin/columns";
export const LOGS = "/admin/logs";